// @flow

import * as React from 'react';

import PreviewImage, { NextButton, PreviousButton } from './PreviewImage';

import styles from './PreviewImages.module.scss';

export type PreviewImageType = {|
  url: string | null,
  placeholder: string | null
|};

type Props = {|
  images: Array<PreviewImageType> | void,
  linkWrapper: ({| children: React.Node |}) => React.Node
|};

export default function PreviewImages(props: Props): React.Node {
  const { images = [], linkWrapper } = props;
  const [index, setIndex] = React.useState(0);

  const image = images[index];
  const showControls = images.length > 1;

  const nextImage = () => {
    setIndex(nextIndex(index, images.length));
  };

  const prevImage = () => {
    setIndex(prevIndex(index, images.length));
  };

  return (
    <div className={styles.container}>
      {linkWrapper({ children: <PreviewImage image={image} /> })}
      {showControls && <NextButton handleClick={nextImage} />}
      {showControls && <PreviousButton handleClick={prevImage} />}
    </div>
  );
}

function nextIndex(index: number, imagesCount: number): number {
  return (index + 1) % imagesCount;
}

function prevIndex(index: number, imagesCount: number): number {
  return (index + imagesCount - 1) % imagesCount;
}
